import React, { useState } from 'react';
import { Container, Image, ListGroup, ListGroupItem } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import useIntersectionObserver from '../hooks/useIntersectionObserver';

const Cronograma = () => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useIntersectionObserver(setIsVisible);

    const courses = [
        { title: 'Explorando la publicidad: pasado, presente y futuro', date: '11-08-2025', link: '/programa1' },
        { title: 'Planificación estratégica: enfoque y eficacia', date: '13-08-2025', link: '/programa2' },
        { title: 'Gestión de clientes: un rol estratégico', date: '18-08-2025', link: '/programa3' },
        { title: 'Social media: cómo conectar con las audiencias', date: '20-08-2025', link: '/programa4' },
        { title: 'El Poder de la creatividad', date: '27-08-2025', link: '/programa5' },
        { title: 'Un León de Oro “made by VML”', date: '01-09-2025', link: '/programa6' },
        { title: 'Hacer que las lindas ideas, sean ideas lindas', date: '03-09-2025', link: '/programa7' },
        { title: 'Customer Experience: creando conexiones de valor', date: '08-09-2025', link: '/programa8' },
        { title: 'Publicidad 3.0: cómo la tecnología está cambiando el juego', date: '10-09-2025', link: '/programa9' },
        { title: 'Publicidad Digital: Estrategia, visión e impacto​', date: '15-09-2025', link: '/programa10' },
        { title: 'Explorando la inteligencia artificial: fundamentos y casos de uso', date: '17-09-2025', link: '/programa11' }
    ];

    return (
        <div>
            <div className='headermodule'>
                <Image src="/images/banner_vml.jpg" fluid />
            </div>

            <Container ref={ref} className={`paddcontainer opacitycontainer ${isVisible ? 'fade-in' : ''}`}>
                <h1>Cronograma</h1>
                <ListGroup>
                    {courses.map((course, index) => (
                        <Link to={course.link} key={index} className="text-decoration-none">
                            <ListGroupItem key={index} className="listcrono zoom">
                                <div><strong>{course.title}</strong></div>
                                <div>Fecha: <em>{course.date}</em></div>
                            </ListGroupItem>
                        </Link>
                    ))}
                </ListGroup>
            </Container>
        </div>
    );
};

export default Cronograma;
